import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, ContentChild, DOCUMENT, Input, OnDestroy, Renderer2, TemplateRef, inject } from "@angular/core";
import { Event, NavigationStart, Router } from "@angular/router";

import { Subscription } from "rxjs";
import { EnvironmentBadgeComponent } from "../environment-badge";
import { NavBarItemComponent } from "./navbar-item/navbar-item.component";
import { TopBarComponent } from "./topbar/topbar.component";

@Component({
  selector: 'lpcr-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    TopBarComponent,
    EnvironmentBadgeComponent
  ]
})
export class NavBarComponent implements OnDestroy {
  private readonly renderer = inject(Renderer2);
  private readonly router = inject(Router);
  private readonly document = inject(DOCUMENT);
  private readonly routerEventSubscription: Subscription;

  @Input()
  public isMenuOpen: boolean = false;

  @Input()
  public displayTopBar: boolean = true;

  @Input()
  public displayMobileMenu: boolean = true;

  @ContentChild('items', { read: TemplateRef })
  public itemsTemplate: TemplateRef<NavBarItemComponent> | null = null;

  @ContentChild('rightItems', { read: TemplateRef })
  public rightItemTemplate: TemplateRef<unknown> | null = null;

  constructor() {
    this.routerEventSubscription = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.isMenuOpen = false;
        this.enableOverflow();
      }
    });
  }

  public ngOnDestroy(): void {
    this.routerEventSubscription.unsubscribe();
  }

  public toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;

    if (this.isMenuOpen) {
      this.disableOverflow();
    }
    else {
      this.enableOverflow();
    }
  }

  private enableOverflow(): void {
    this.renderer.removeClass(this.document.body, 'overflow-hidden');
  }

  private disableOverflow(): void {
    this.renderer.addClass(this.document.body, 'overflow-hidden');
  }
}
